import { createStyles, makeStyles, Theme } from '@material-ui/core';
import classnames from 'classnames';
import React from 'react';

type Props = {
  text?: string;
  className?: string;
  maxLine?: number;
  style?: React.CSSProperties;
};

export function LinesEllipsis({ text, className, maxLine, style }: Props): React.ReactElement {
  const classes = useStyles({ maxLine });

  return (
    <span style={style} className={classnames(classes.root, className)}>
      {text}
    </span>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: ({ maxLine = 2 }: { maxLine?: number }) => ({
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      '-webkit-line-clamp': maxLine,
      '-webkit-box-orient': 'vertical',
    }),
  })
);
